











































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Search, List, Sticky, Icon } from 'vant';
import { voteList } from './api/index';
import { namespace, State } from 'vuex-class';
import ListItem from './components/ListItem.vue';
import * as mutationTypes from './store/mutation-types';
import { appShare, wxShareInfo } from '@/common/ts/common';

const Modules = namespace('SCSBY20200526');
Vue.use(Search)
  .use(List)
  .use(Sticky)
  .use(Icon);
@Component({
  components: {
    ListItem,
  },
})
export default class SearchPage extends Vue {
  public value: string = '';
  public type: any;
  public recordList: any[] = [];
  public List: any[] = [];
  public ifDoSearch: boolean = true;
  public loading: boolean = false;
  public loadingStatus: boolean = false;
  public valueText: string = '';
  public finished: boolean = false;
  public page = 1;
  public showHistory: boolean = true;
  public failShow: boolean = false;
  public showList: boolean = false;

  @Modules.Mutation(mutationTypes.SAVE_SCHOOL_DATA) saveSchoolData!: (
    schooldata: any,
  ) => void;
  @Watch('value')
  public onKeywordChange(newval: string, val: string) {
    if (!newval) {
      this.reset();
      console.log('监听value');
    }
  }
  @Watch('$route')
  public onRouteChange() {
    this.reset();
    this.init();
    // console.log('SearchPage路径改变');
  }
  public reset() {
    this.value = '';
    this.failShow = false;
    this.showHistory = true;
    this.showList = false;
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.List = [];
  }
  public created() {
    this.init();
    // 分享
    appShare({
      title: '山城榜样说',
      url: window.location.href,
      subtitle: '聆听TA的故事，传承榜样精神',
      classId: -1,
      id: -1,
      image:
        'http://image2.cqcb.com/d/file/topics/activity/2020-05-27/JypEzy3YSW.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '山城榜样说',
      subtitle: '聆听TA的故事，传承榜样精神',
      image:
        'http://image2.cqcb.com/d/file/topics/activity/2020-05-27/JypEzy3YSW.jpeg',
    });
  }
  public init() {
    // 搜索记录
    if (localStorage.getItem('CDWNSearchList')) {
      this.recordList = JSON.parse(
        localStorage.getItem('CDWNSearchList') || '[]',
      );
    } else {
      localStorage.setItem('CDWNSearchList', JSON.stringify([]));
    }
  }
  public onLoad() {
    if (this.loadingStatus === false) {
      // 解决下拉加载两次page为1的问题
      this.loadingStatus = true;
      // 区别onSearch和下拉方法
      this.ifDoSearch = false;
      setTimeout(() => {
        this.onSearch(this.valueText);
      }, 200);
    }
  }
  public onSearch(e: any) {
    if (e) {
      this.showHistory = false;
      this.showList = true;
      this.failShow = false;
      this.loading = true;
      this.finished = false;
      this.loadingStatus = true;
      // value为输入框数据；valueText为搜索数据
      this.valueText = e;
      if (this.ifDoSearch === true) {
        this.page = 1;
        this.List = [];
      }
      // 设置搜索历史
      this.setLocalHistory();
      // 获取作文列表搜索结果
      voteList({ search: this.valueText, page: this.page }).then((res: any) => {
        // 搜索失败
        if (this.page === 1 && res.data.length <= 0) {
          this.failShow = true;
          this.showList = false;
        }
        if (res.data === '') {
          this.finished = true;
        } else {
          // 注：undefined和null无法转成对象
          const searchListArr = Object.values(res.data);
          this.List = [...this.List, ...searchListArr];
          this.page = this.page + 1;
        }
        this.loading = false;
        this.loadingStatus = false;
        this.ifDoSearch = true;
      });
    }
  }
  public onRecordSearch(index: any) {
    // 重置上一次搜索数据
    this.reset();
    // 设置当前关键词
    this.value = this.recordList[index];
    this.onSearch(this.recordList[index]);
    this.recordList.splice(this.recordList.indexOf(this.value), 1);
    this.recordList.unshift(this.value);
    window.localStorage.setItem(
      'CDWNSearchList',
      JSON.stringify(this.recordList),
    );
  }
  public setLocalHistory() {
    // 存入搜索记录
    let localHistory = JSON.parse(
      localStorage.getItem('CDWNSearchList') || '[]',
    );
    if (this.value !== '') {
      localHistory.unshift(this.value);
    }
    // 数组去重
    const uniqueArr = new Set(localHistory);
    // 将其他对象转换成数组
    localHistory = Array.from(uniqueArr).slice(0, 10);
    localStorage.setItem('CDWNSearchList', JSON.stringify(localHistory));
    this.recordList = localHistory;
  }
  // 清除全部搜索记录
  public deleteList() {
    localStorage.removeItem('CDWNSearchList');
    this.recordList = [];
  }
  // 清除某个搜索记录
  public deleteListItem(index: any) {
    this.recordList.splice(index);
    const deleteItemList = JSON.parse(
      localStorage.getItem('CDWNSearchList') || '[]',
    );
    deleteItemList.splice(index, 1);
    localStorage.setItem('CDWNSearchList', JSON.stringify(deleteItemList));
    this.recordList = deleteItemList;
  }
  // 取消搜索
  public cancelSearch() {
    this.$router.go(-1);
    this.reset();
  }
}
